import SignupForm from '../components/SignupForm/SignupForm'

export default function SignupPage(props) {

  return (
    <SignupForm />
  )
}